import { COOKIE_LOAN_SEARCH } from '@/constants/cookies';
import { getLoanSearch } from '@/graphql/queries/banking/loan';
import lang from '@/lang/middleware/products/banking/loans';

export default async ({ $api, $apolloQuery, $cookies, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const setDefaultSearch = () => {
    $cookies.remove(COOKIE_LOAN_SEARCH);
    store.commit('search/reset', { type: 'loan' });
  };
  const code = $cookies.get(COOKIE_LOAN_SEARCH);
  const description = store.$i18n.t('index.description');
  const subtitle = store.$i18n.t('index.subtitle');
  const title = store.$i18n.t('index.title');
  const warning = store.$i18n.t('index.warning');
  store.commit('jumbotron/SET_JUMBOTRON', { extra: 'site-jumbotron-warning', props: { warning }, subtitle, title, type: 'expanded' });
  store.commit('pageContent/setHead', { description, title });
  await $api('banking/loansearches').then(r => store.commit('products/setValidations', r));
  if (code && typeof code === 'string') {
    await $apolloQuery(getLoanSearch, { code }).then(search => store.commit('search/set', search)).catch(_ => setDefaultSearch());
  } else {
    setDefaultSearch();
  }
};
